import React, { useState, useEffect, useContext } from "react";
import { Groups_func } from "../../api/devices/groups/groups_func";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Breadcrumb, Stack, StackItem, TooltipHost } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Toast, ToastTitle, useId, ToastPosition, useToastController, ToastBody, ToastTrigger, Link, Input, Tooltip } from "@fluentui/react-components";
import { PhoneLaptop20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, FilterAdd20Filled, Info16Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { GlobalContext } from "../../hooks/globalContext";
import { ToastComponent } from "../../components/toast/toast.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import DialogBox from "../../components/dialog/dialog.component";
import { lightTheme, primaryIcon, overflowDivider, SubSectionResponsive, DynamicBoxingCSS, parentHome, dividerWidthStyle, wraperStyle, secondaryIcon, dashboardTheme, timezoneInfo, BreadcrumbsBorder } from "../../styles/customStyles";
import { usePermissionStore } from "../../Store/permissionStore";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { alertTroubleShootPush, getAlertDetails, otherSolutionsList } from '../../api/troubleshoot/alert_devices_func';
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import moment from "moment-timezone";



export const Alert_Devices = () => {
    const [isIconEnabled, setIconEnabled] = useState(false);
    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    const tenant = contextValue.tenantName;
    const [tableData, setTableData] = useState([]);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [deviceSearchVal, setDeviceSearchVal] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [deleteDevices, setDeleteDevices] = useState(false);
    const [overLayData, setOverLayData] = useState<any>({});
    const [devicesTableData, setDevicesTableData] = useState([]);
    const [devicesTableData1, setDevicesTableData1] = useState([]);
    const [selectedTableData, setSelectedTableData] = useState([]);
    const [selectedDevices, setSelectedDevices] = useState<any>([]);
    const [isToast, setIsToast] = useState(false);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [devicesOfTenant, setDevicesOfTenant] = useState<any>(null);
    const [selectedValue, setSelectedValue] = useState(0);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [getEventDetails, setGetEventDetails]: any = useState(false);
    const [machineName, setMachineName]: any = useState(null);
    const [loading, setLoading] = useState(true);

    const [csvDevicesList, setCsvDevicesList] = useState<any>([]);
    const [troubleshooterSolutionList, setTroubleshooterSolutionList] = useState<any>([]);
    const [viewSolutions, setViewSoultions] = useState<object>([]);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [messagebar2, setmessagebar2] = useState(false);
    const [toastMessage, setToastMessage] = useState('Push Successful');
    const [toastIntent, setToastIntent] = useState('success');
    const [troubleshootErrorMsg, setTroubleshootErrorMsg] = useState<boolean>(false)
    const [previousJob, setPreviousJob]: any = useState(false);
    const [rcmdSolutiondropDownValue, setrcmdSolutionDropDownValue] = useState<any>('');
    const [otherSolutiondropDownValue, setotherSolutionDropDownValue] = useState<any>('');
    const [isOverlayFilter, setIsOverlayFilter] = useState(false);
    const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
    const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
    const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
    const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
    const [isOverlayResetDisabled, setOverlayResetDisabled] = useState(true);
    const [isRcmdSolutionDisabled, setRcmdSolutionDisabled] = useState<boolean>(false);
    const [isOtherSolutionDisabled, setOtherSolutionDisabled] = useState<boolean>(false);
    const { permissions } = usePermissionStore();
    const handle = useFullScreenHandle();

    const handleOverlayFilter = (): any => {
        const value1 = dropDownValue1Overlay;
        const value2 = dropDownValue2Overlay;
        const result = value1 + " : " + value2;
        setOverlayFilterArray([...overlayFilterArray, result])
        setIsOverlayFilter(true);
        setDropDownValue1Overlay('');
        setDropDownValue2Overlay('');
    }

    const handleCloseOverlayFilter = (index: any): any => {
        console.log(" handleCloseOverlayFilter clicked");
        const updatedArray = overlayFilterArray.filter((x, itemIndex) => itemIndex !== index);
        setOverlayFilterArray(updatedArray);
        setIsOverlayFilter(false);
    }

    const overlayInputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        const regexSN = /^[A-Za-z0-9_-]*$/;
        if (name === 'filter' && dropDownValue1Overlay === ("Device Name")) {
            if (regexSN.test(enteredValue)) {
                setDropDownValue2Overlay(enteredValue);
            }
        }
    }

    // const [permissions, setPermissions] = useState(['']);
    const handleFilterArray = (): any => {
        const value1 = dropDownValue1
        const value2 = dropDownValue2;
        if (value1 !== undefined && value1 !== "" && value2 !== undefined && value2 !== "") {
            const result = value1 + " : " + value2;
            setFilterArray([...filterArray, result]);
            setIsFilter(true);
        }
    }
    const handleCloseFilter = (index: any): any => {
        console.log("cllciked");
    }
    useEffect(() => {
        if (filterArray.length > 0)
            setResetDisabled(false)
    }, [filterArray])

    useEffect(() => {
        setOverlayResetDisabled(overlayFilterArray.length > 0 ? false : true);
    }, [overlayFilterArray]);

    const inputChange = (e: any) => {
        const enteredValue = e.target.value;
        console.log("entered value", enteredValue)
        let name = e.target.name;
        if (name === 'filter') {
            setDropDownValue2(enteredValue);
        }
    }

    var menuItems: any = [];
    const toasterId = useId();
    const { dispatchToast } = useToastController(toasterId);
    const [position, setPosition] = React.useState<ToastPosition>("top-end");

    menuItems.push
        (
            <FluentProvider theme={lightTheme}>
                <MenuItem onClick={() => navigate("/manage/troubleshoot/alert/devices")}
                    icon={
                        <Stack horizontal tokens={{ childrenGap: 40 }}>
                            <StackItem><Text></Text></StackItem>
                            <StackItem> <PhoneLaptop20Regular {...primaryIcon} /> </StackItem>
                        </Stack>}>
                    <Stack tokens={{ childrenGap: 30 }} horizontal>
                        <StackItem><Text></Text></StackItem>
                        <StackItem> <Caption1> Devices </Caption1> </StackItem>
                        <StackItem> <Stack tokens={{ childrenGap: 80 }} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
                        {/* SPACING IN INLINE SIDEBAR */}
                    </Stack>
                </MenuItem>
            </FluentProvider>
        );
    //inline side menu content code ends here

    //data table column name code starts here
    var columns = [
        { key: "device_names", label: <Body1Strong>&nbsp; Device Name </Body1Strong> },
        { key: "date", label: <Body1Strong> Date </Body1Strong> },
        // { key: "date_timezoned",
        //     label: <>
        //         <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
        //             <StackItem>
        //                 <Body1Strong>&nbsp;&nbsp;Date</Body1Strong>
        //             </StackItem>
        //             <StackItem align="center">
        //                 <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
        //                     <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
        //                 </Tooltip>
        //             </StackItem>
        //         </Stack>
        //     </>
        // },
        { key: "count", label: <Body1Strong> Count </Body1Strong> },
        // { key: "status", label: <Body1Strong> Last Event </Body1Strong> },
    ];
    var columns1 = [
        { key: "device_name", label: <Caption1> Device Name </Caption1> },
        // { key: "", label: <Caption1> Device belongs to mutliple classification </Caption1>  },
        // { key: "manufacturer", label: <Caption1> Manufacturer </Caption1> },
        { key: "os", label: <Caption1> Operating System </Caption1> },
        { key: "nanoheal_version", label: <Caption1> Nanoheal Version </Caption1> },
        // { key: "os", label: <Caption1> Last check-in 24 hours </Caption1> },
        // { key: "os", label: <Caption1> Last-check in 1 week </Caption1> },
        { key: "installation_date", label: <Caption1> Installation Date </Caption1> },
    ];
    var overlayBasicColumns = [
        { key: "device_name", label: <Body1Strong> Device Name</Body1Strong> },
        { key: "client_time", label: <Body1Strong> Client Time  </Body1Strong> },
        { key: "server_time", label: <Body1Strong> Server Time  </Body1Strong> }
    ];

    //data table column name code ends here
    // overflow set contents code starts here
    var overFlowComponent = {
        data:
            <>
                <StackItem><Text></Text></StackItem>
                <StackItem>
                    <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); }}>
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
                            <StackItem> <Caption1> Refresh </Caption1> </StackItem>
                        </Stack>
                    </Button>
                    {
                        permissions.includes("deviceClassification_Read") ? (
                            <TooltipHost content="This feature is not available for you!">
                                <Button shape="circular" disabled={loading} appearance="subtle" size="small">
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>{loading ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </TooltipHost>

                        ) : permissions.includes("all") || permissions.includes("deviceClassification_Fullaccess") || permissions.includes("deviceClassification_ReadandExport") ? (

                            <CSVLink id="csv-export-link" data={exportData} filename={`${contextValue.selectedRowDetails.name}_Details.csv`}>
                                <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => {/*userActivity('Export', `{"summary":"Devices list exported"`); */ }}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </CSVLink>
                        ) :
                            <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                <Button shape="circular" appearance="subtle" size="small" disabled>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                                        <StackItem> <Caption1> Export </Caption1> </StackItem>
                                    </Stack>
                                </Button>
                            </Tooltip>
                    }

                    {/* <Button shape="circular" appearance="subtle" size="small" onClick={() => { userActivity('Export', `{"summary":"Devices list exported"`); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
            <StackItem>{loading?<ArrowDownload20Regular {...secondaryIcon} />:<ArrowDownload20Regular {...primaryIcon} />} </StackItem>
            <StackItem> <Caption1> Export </Caption1> </StackItem>
            </Stack>
        </Button> */}


                    {/* <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
                <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
                <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
            </Button> */}
                </StackItem>

                <StackItem grow shrink>
                    <Stack horizontalAlign="end">
                        <StackItem grow shrink>
                            <FullScreenButton handle={handle} />
                        </StackItem>
                    </Stack>
                </StackItem>
                {/* </Stack> */}
                {/* </Stack> */}

            </>
        ,
    };
    // overflow set contents code ends here

    useEffect(() => {
        console.log("exportDetails exportDetails=", exportDetails);
        var tempExportData: any = [];
        exportDetails?.length > 0 && exportDetails.map((val: any) => {
            tempExportData.push({
                device_names: val.host,
                manufacturer: val.Census_AssestData.length > 0 ? val.Census_AssestData[0].value.chassismanufacturer : "-",
                os: val.os,
                osversion: val.osversion,
                nanoheal_version: val.clientversion,
                installation_date: new Date(val.born * 1000).toLocaleString(),
                last_event: new Date(val.last * 1000).toLocaleString()
            });
        });
        setExportData(tempExportData);
    }, [exportDetails]);

    var tempTableData: any = [];
    var tempExportData: any = [];

    useEffect(() => {
        contextValue?.logedInFrom?.device?.length > 0 && setSearchVal(contextValue.logedInFrom.device);
    }, [contextValue.logedInFrom]);

    useEffect(() => {
        const fetchData = async () => {
            const apiUrl = 'https://pinot-dev.nanoheal.work/sql';
            // If searchVal exists, modify the SQL query to include search filter
            var whereCondition = '';
            if (searchVal) {
                whereCondition = ` AND machine LIKE '%${searchVal}%' `;
            }
            let sqlQuery = `select count(*), machine, window_end from t1_312_notification where name = '${contextValue.selectedRowDetails.name}' ${whereCondition} group by machine, window_end`;
            // sqlQuery += ' limit 1000';
            const requestBody = {
                sql: sqlQuery,
                trace: false,
                queryOptions: '',
            };
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                throw new Error(`No result`);
            }
            const responseData = await response.json();
            console.log("responseData=", responseData);
            const rowData = responseData != undefined && responseData?.resultTable != undefined ? responseData?.resultTable?.rows : [];
            const uniqueData: any = [];

            if (rowData.length > 0) {
                rowData.map((row: any) => {
                    const isDuplicate = uniqueData.some((existingRow: any) =>
                        JSON.stringify(existingRow) === JSON.stringify(row)
                    );
                    if (!isDuplicate) {
                        uniqueData.push(row);
                    }
                });
                var cnt = 0;
                uniqueData !== undefined && uniqueData !== null ? uniqueData.map((data: any, i: any) => {
                    if (i >= (50 * (currentPageNo - 1) && cnt < 50)) {
                        cnt++;
                        tempExportData.push({
                            'Device Names': data[1],
                            'Date': data[2],
                            'Count': data[0]
                        });
                        tempTableData.push({
                            checkbox: 'hide',
                            device_names: { label: <Button appearance="transparent" size="small" onClick={() => { setOverlayOpen(true); setGetEventDetails(true); setMachineName(data[1]); }}> {data[1]} </Button> },
                            date: { label: <Caption1> {moment(data[2], "YYYY-MM-DD HH:mm:ss.S").format("MM/DD/YYYY HH:mm")} </Caption1> },
                            // date_timezoned: { label: <Caption1>  {val.time ? convertToLocalTimezone(val.time, userTimeZone) : ''} </Caption1>, id: `${i}` },
                            count: { label: <Caption1> {data[0]} </Caption1> },
                        });
                    }
                }) : (tempTableData = []);
                setExportData(tempExportData);
                tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
                setLoading(false);
                setTotalRecords(uniqueData?.length);
                setTotalPages(Math.ceil((uniqueData?.length) / 50));
            } else {
                setLoading(false);
                setTableData([]);
                setTotalRecords(0);
                setTotalPages(0);
            }
        };
        fetchData();
    }, [searchVal, currentPageNo]);

    useEffect(() => {
        const fetchBasicData = async () => {
            const apiUrl = 'https://pinot-dev.nanoheal.work/sql';
            let sqlQuery = `select machine, ctime, servertime from t1_d177_notification where alertname = '${contextValue.selectedRowDetails.name}' and machine = '${machineName}'`;
            // sqlQuery += ' limit 1000';
            const requestBody = {
                sql: sqlQuery,
                trace: false,
                queryOptions: '',
            };
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });
            if (!response.ok) {
                throw new Error(`No result`);
            }
            const responseData = await response.json();
            console.log("responseData=", responseData);
            const rowData = responseData != undefined && responseData?.resultTable != undefined ? responseData?.resultTable?.rows : [];
            if (rowData.length > 0) {
                tempTableData = [];
                rowData.map((data: any) => {
                    tempTableData.push({
                        checkbox: 'hide',
                        device_name: { label: <Caption1> {data[0]} </Caption1> },
                        client_time: { label: <Caption1> {data[1]} </Caption1> },
                        server_time: { label: <Caption1> {data[2]} </Caption1> },
                    });
                });
                tempTableData.length > 0 ? setDevicesTableData(tempTableData) : setDevicesTableData([]);
            } else {
                setDevicesTableData([]);
            }
            setGetEventDetails(false);
        }
        const fetchEventData = async () => {
            const apiUrl = 'https://pinot-dev.nanoheal.work/sql';
            var sqlQuery = '';
            if (contextValue.selectedRowDetails.id == 95) {
                sqlQuery = `select ctime, servertime, scrip, t1_pctUsed, t1_drive, t1_kbFree, t1_kbUsed, t1_kbTotal, t1_changeThldKb, t1_drivesToIgnore, t1_absoluteThldKbOrPct, t1_numOfSamplesForChangeThld, t1_pctFreeSpaceBelowWhichToReport, t2_log from t1_d177_notification where alertname = '${contextValue.selectedRowDetails.name}' and machine = '${machineName}'`
            } else if (contextValue.selectedRowDetails.id == 310) {
                sqlQuery = `select ctime, servertime, scrip, t1_sysCpuUsagePercentageAvg, t1_sysMemUsagePercentageAvg,  t1_monitEndTime, t1_monitStartTime, t1_noOfProcessesRunning from t1_d177_notification  where alertname = '${contextValue.selectedRowDetails.name}' and machine = '${machineName}'`;
            } else if (contextValue.selectedRowDetails.id == 6) {
                sqlQuery = `select ctime, servertime, scrip, t1_AverageQueueLength,t1_PercentUtilization, t1_mSecSamplingPeriod, t1_InterruptRatePerSecond, t1_NumberOfProcessesRunning, t1_avgQueueLength, t1_pctUtilization, t1_samplingPeriodMsec, t1_interruptRatePerSec, t1_noOfProcessesRunning, t2_log, t3_Process, t3_ProcessCPU, t3_ProcessPID, t3_ProcessSize, t3_ProcessElapsed, t3_ProcessVersion, t3_ProcessImageName, t3_ProcessMemUsage_Kb, t3_ProcessCreationDate, t3_ProcessMemUsagePercent, t3_ProcessLastModifiedDate from t1_d177_notification where alertname = '${contextValue.selectedRowDetails.name}' and machine = '${machineName}'`;
            }
            // sqlQuery += ' limit 1000';

            const requestBody = {
                sql: sqlQuery,
                trace: false,
                queryOptions: '',
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            if (!response.ok) {
                throw new Error(`No result`);
            }

            const responseData = await response.json();
            console.log("responseData=", responseData);

            const rowData = responseData != undefined && responseData?.resultTable != undefined ? responseData?.resultTable?.rows : [];
            try {

            } catch (error) {

            }
            if (rowData.length > 0) {
                tempTableData = [];
                rowData.map((data: any) => {
                    if (contextValue.selectedRowDetails.id == 95) {
                        tempTableData.push({
                            checkbox: 'hide',
                            client_time: { label: <Caption1> {data[0]} </Caption1> },
                            server_time: { label: <Caption1> {data[1]} </Caption1> },
                            dart: { label: <Caption1> {data[2]} </Caption1> },
                            details: {
                                label: <Stack>
                                    <StackItem>
                                        <Caption1>Percentage used - {data[3]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Drive - {data[4]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Memory free(kB) - {data[5]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Memory used(kB) - {data[6]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Total memory(kB) - {data[7]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Change Threshold(kB) - {data[8]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Drives to ignore - {data[9]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Absolute Threshold(kB/%) - {data[10]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>No. of samples for change threshold - {data[11]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Percentage free space below which to report - {data[12]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>Log - {data[13]}</Caption1>
                                    </StackItem>
                                </Stack>
                            }
                        });
                    } else if (contextValue.selectedRowDetails.id == 310) {
                        tempTableData.push({
                            checkbox: 'hide',
                            client_time: { label: <Caption1> {data[0]} </Caption1> },
                            server_time: { label: <Caption1> {data[1]} </Caption1> },
                            dart: { label: <Caption1> {data[2]} </Caption1> },
                            details: {
                                label: <Stack>
                                    <StackItem>
                                        <Caption1> sysCpuUsagePercentageAvg - {data[3]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>sysMemUsagePercentageAvg - {data[4]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_monitEndTime - {data[5]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_monitStartTime - {data[6]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>No.ofProcessRunning - {data[7]}</Caption1>
                                    </StackItem>
                                </Stack>
                            }
                        });
                    } else if (contextValue.selectedRowDetails.id == 6) {
                        tempTableData.push({
                            checkbox: 'hide',
                            client_time: { label: <Caption1> {data[0]} </Caption1> },
                            server_time: { label: <Caption1> {data[1]} </Caption1> },
                            dart: { label: <Caption1> {data[2]} </Caption1> },
                            details: {
                                label: <Stack>
                                    <StackItem>
                                        <Caption1>t1_AverageQueueLength {data[3]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_PercentUtilization - {data[4]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_mSecSamplingPeriod - {data[5]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_interruptRatePerSec - {data[6]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_NumberOfProcessesRunning - {data[7]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_avgQueueLength - {data[8]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_pctUtilization - {data[9]}</Caption1>
                                    </StackItem>
                                    <StackItem>
                                        <Caption1>t1_samplingPeriodMsec - {data[10]}</Caption1>
                                    </StackItem>
                                </Stack>
                            }
                        });
                    }
                });

                tempTableData.length > 0 ? setDevicesTableData1(tempTableData) : setDevicesTableData1([]);
            } else {
                setDevicesTableData1([]);
            }
            setGetEventDetails(false);
        }
        if (getEventDetails) {
            fetchBasicData();
            fetchEventData();
        }
        getAlertDetails({ contextValue, setTroubleshooterSolutionList });
    }, [getEventDetails, machineName]);

    //overlay code starts here
    const handleRcmdDropdownValue = (value) => {
        setrcmdSolutionDropDownValue(value);
        setotherSolutionDropDownValue(null);
        setRcmdSolutionDisabled(false);
        setOtherSolutionDisabled(true);
    }

    const handleOtherDropdownValue = (value) => {
        setrcmdSolutionDropDownValue(null);
        setotherSolutionDropDownValue(value);
        setRcmdSolutionDisabled(true);
        setOtherSolutionDisabled(false);
    }

    const handleClearSolutions = () => {
        setRcmdSolutionDisabled(false)
        setOtherSolutionDisabled(false)
        setrcmdSolutionDropDownValue('')
        setotherSolutionDropDownValue('')
    }
    const handleTroubleShooterPush = (): any => {
        const solution = rcmdSolutiondropDownValue ? rcmdSolutiondropDownValue : otherSolutiondropDownValue;
        const pushData = {
            serviceTag: `${machineName}`,
            solutionVar: `${contextValue.selectedRowDetails.name}`,
            deviceStatus: 'online',
            applicationname: `${solution}`,
            tenant,
            setmessagebar2,
            setTroubleshootErrorMsg,
            setToastMessage,
            setToastIntent,
            setPreviousJob,
            previousJob,
            setOverlayOpen
        }
        alertTroubleShootPush(pushData)
        handleClearSolutions()
    }

    useEffect(() => {
        otherSolutionsList({ setViewSoultions, troubleshooterSolutionList, tenant })
    }, [])

    useEffect(() => {
        var defaultSelected: any = [];
        setOverLayData({
            size: "large",
            headerTitle:
                (<>
                    <FluentProvider theme={dashboardTheme}>
                        <Title3> Alert: {contextValue.selectedRowDetails.name} </Title3>
                    </FluentProvider>
                </>
                ),
            isTabs: true,
            tabItems: {
                'Basic Details': <>
                    {/* <FluentProvider theme={dashboardTheme}>
                        <Stack horizontal>
                            <StackItem> */}

                    <Stack tokens={{ childrenGap: 10, padding: "10px 0px" }}>
                        <StackItem>
                            <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                                <SearchBar columnSearch={"for Device Name"} searchVal={deviceSearchVal} setSearchVal={setDeviceSearchVal} disabled={loading || overlayFilterArray.length === 0 }/>
                                <StackItem>
                                    <MenuDropdown open={filterMenuOpenOverlay} btn={
                                        <MenuButton disabled={loading || overlayFilterArray.length ===0} shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <FilterAdd20Filled {...primaryIcon} />
                                                <Body1> Filter </Body1>
                                            </Stack>
                                        </MenuButton>
                                    } itemVal={
                                        <>
                                            <Body1Strong> Add a Filter </Body1Strong>
                                            <Divider />
                                            <MenuList>
                                                <Stack tokens={{ childrenGap: 5 }}>
                                                    <StackItem> <Text></Text> </StackItem>
                                                    <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                    <DropdownComponent optionData={overlayBasicColumns} setDropDownValue={setDropDownValue1Overlay} dropDownvalue={dropDownValue1Overlay} />
                                                    <StackItem> <Divider /> </StackItem>
                                                    <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                    {/* {dropDownValue1Overlay === "Operating System" && <DropdownComponent optionData={isOsName} setDropDownValue={setDropDownValue2Overlay} dropDownvalue={dropDownValue2Overlay} />} */}
                                                    {dropDownValue1Overlay === "Device Name" && <Input size='small' onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />}
                                                    {dropDownValue1Overlay === "Client Time" || dropDownValue1Overlay === "Server Time" && <DatepickerComponent setDropDownValue2Overlay={setDropDownValue2Overlay} maxDate={true} />}
                                                    <StackItem>
                                                        <Divider />
                                                    </StackItem>
                                                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                        <StackItem>
                                                            <Button shape="circular" appearance="primary" onClick={() => { handleOverlayFilter(); setFilterMenuOpenOverlay(false) }}
                                                                disabled={!dropDownValue1Overlay || !dropDownValue2Overlay || overlayFilterArray.includes(`${dropDownValue1Overlay}:`)}>
                                                                <Caption1> Apply </Caption1>
                                                            </Button>
                                                        </StackItem>
                                                        <StackItem>
                                                            <Button shape="circular" onClick={() => setFilterMenuOpenOverlay(false)}>     <Caption1> Cancel </Caption1>
                                                            </Button>
                                                        </StackItem>
                                                    </Stack>
                                                </Stack>
                                            </MenuList>
                                        </>}
                                    />
                                </StackItem>

                                <StackItem onClick={() => { setOverlayFilterArray([]); setIsFilter(false); setDropDownValue2(''); setOverlayResetDisabled(true); }}>
                                    <Button shape="circular" appearance="subtle" size="small" disabled={isOverlayResetDisabled}>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <FilterDismiss20Filled /> </StackItem>
                                            <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                        </Stack>
                                    </Button>
                                </StackItem>
                                <StackItem>
                                    {overlayFilterArray.length > 0 && overlayFilterArray.map((item, index) => (
                                        <Button shape="circular" size="small">
                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                <StackItem> {item} </StackItem>
                                                <StackItem>
                                                    <Stack tokens={{ childrenGap: 1 }}>
                                                        <StackItem><Text></Text></StackItem>
                                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseOverlayFilter(index) }} /></StackItem>
                                                    </Stack>
                                                </StackItem>
                                            </Stack>
                                        </Button>
                                    ))}
                                </StackItem>
                            </Stack>
                        </StackItem>
                        <StackItem><FluentProvider theme={dashboardTheme}>
                            {devicesTableData.length > 0 ? (<DataTable tableData={devicesTableData} columns={overlayBasicColumns} isSubTable={true} defaultSelected={defaultSelected} />) : <Stack><StackItem><Caption1> No data found.</Caption1></StackItem></Stack>}
                        </FluentProvider></StackItem>

                    </Stack>
                    {/* </StackItem>
                        </Stack>
                    </FluentProvider> */}
                </>,
                'Fix Issue': <>
                    <FluentProvider theme={dashboardTheme}>
                        <Stack tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                            <Stack grow horizontal tokens={{ childrenGap: 10 }}>
                                <StackItem><Body1Strong> Recommended solution </Body1Strong></StackItem>
                                <StackItem>
                                    <DropdownComponent
                                        disabled={isRcmdSolutionDisabled}
                                        optionData={troubleshooterSolutionList}
                                        dropDownvalue={rcmdSolutiondropDownValue}
                                        setDropDownValue={(value) => handleRcmdDropdownValue(value)}
                                        defaultSelected={rcmdSolutiondropDownValue}
                                    />
                                </StackItem>
                            </Stack>

                            {/* {troubleshooterSolutionList.map((solution, index) => (
                            <StackItem>
                                 <Button shape="circular" key={index} size="small" onClick={() => {setIsToast(true)}}>{solution}</Button> 
                            </StackItem>
                            ))} */}

                            <StackItem>
                                <Stack horizontal grow tokens={{ childrenGap: 70 }}>
                                    <StackItem><Body1Strong> Other solutions </Body1Strong></StackItem>
                                    <StackItem>
                                        <DropdownComponent
                                            disabled={isOtherSolutionDisabled}
                                            optionData={viewSolutions}
                                            dropDownvalue={otherSolutiondropDownValue}
                                            setDropDownValue={(value) => handleOtherDropdownValue(value)}
                                            defaultSelected={otherSolutiondropDownValue}
                                        />
                                    </StackItem>
                                </Stack>
                                {/* <Body1Strong> Other solution </Body1Strong>  */}
                                {/* <Button shape="circular" size="small" onClick={() => {navigate("/manage/troubleshoot/troubleshoot")}}>Go to Troubleshooter</Button>  */}
                            </StackItem>
                        </Stack>
                    </FluentProvider>
                </>
            },
            footerData:
                (
                    <>
                        <DialogBox
                            headerButton={
                                <>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            <Button shape="circular" appearance="primary" size="small" onClickCapture={() => setCurrentPageNo(1)}
                                                disabled={rcmdSolutiondropDownValue == '' || otherSolutiondropDownValue == '' ? true : false}>
                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                    <StackItem> <Caption1> Push Solution </Caption1> </StackItem>
                                                </Stack>
                                            </Button>
                                        </StackItem>
                                    </Stack>
                                </>
                            }
                            content={`Are you sure you want to execute the solution on ${machineName} device?`}
                            footer=
                            {
                                <>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                        <StackItem>
                                            {<Button shape="circular" appearance="primary" onClick={handleTroubleShooterPush} size="small" >Confirm </Button>}
                                        </StackItem>
                                        <StackItem>
                                            <Button shape="circular" size="small">Cancel</Button>
                                        </StackItem>
                                    </Stack>
                                </>
                            }
                        />

                        <DialogBox
                            headerButton={
                                <>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        <StackItem>
                                            <Button shape="circular" appearance="primary" size="small" /*onClick={() => { setPending(true) }}*/> Clear Pending queue </Button>
                                        </StackItem>
                                    </Stack>
                                </>
                            }
                            content={"Are you sure you want to proceed with clearing pending jobs"}
                            footer=
                            {
                                <>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                        <StackItem>
                                            {<Button shape="circular" appearance="primary" size="small" onClickCapture={() => { "add state to call the pop up" }}>Confirm</Button>}
                                        </StackItem>
                                        <StackItem>
                                            <Button shape="circular" size="small">Cancel</Button>
                                        </StackItem>
                                    </Stack>
                                </>
                            }
                        />
                        <>
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>
                                    <Button shape="circular" appearance="primary" size="small" onClick={handleClearSolutions}
                                        disabled={rcmdSolutiondropDownValue == '' || otherSolutiondropDownValue == '' ? true : false}>
                                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                                            <StackItem> <Caption1> Clear Solutions </Caption1> </StackItem>
                                        </Stack>
                                    </Button>
                                </StackItem>
                            </Stack>
                        </>
                    </>
                ),
        });
    }, [devicesTableData, devicesTableData1, selectedValue, selectedTableData, troubleshooterSolutionList, rcmdSolutiondropDownValue, otherSolutiondropDownValue, overlayFilterArray, isOverlayFilter, deviceSearchVal, filterMenuOpenOverlay, isRcmdSolutionDisabled, isOtherSolutionDisabled]);
    //overlay code ends here

    var validDevicesList: any = [];
    var inValidDevicesList: any = [];
    var alldDevicesList: any = [];
    useEffect(() => {
        if (csvDevicesList.length > 0) {
            validDevicesList = [];
            inValidDevicesList = [];
            alldDevicesList = [];
            devicesOfTenant.core_Census.map((val: any) => {
                alldDevicesList.push(val.host);
            });
            csvDevicesList.map((val: any) => {
                var deviceName = val.replace(/[\r\n]/g, '');
                alldDevicesList.includes(deviceName) ? validDevicesList.push(deviceName) : inValidDevicesList.push(deviceName);
            });
            validDevicesList.length > 0 ? setSelectedTableData(validDevicesList) : setSelectedTableData([]);
            contextValue.setSelectedRowIdInSubTable(validDevicesList);
        }
    }, [devicesOfTenant, csvDevicesList]);

    useEffect(() => {
        handleClearSolutions()
        !overlayOpen && setSelectedValue(0);
    }, [overlayOpen]);

    useEffect(() => {
        console.log("after deletion=", deleteDevices);
        !deleteDevices && contextValue.setSelectedRowIdInTable([]);
        !deleteDevices && contextValue.setSelectedRowIdInSubTable([]);
    }, [deleteDevices]);

    useEffect(() => {
        console.log("SelectedRowIdInTable=", contextValue.selectedRowIdInTable);
    }, [contextValue.selectedRowIdInTable]);

    useEffect(() => {
        // contextValue.setSelectedRowIdInSubTable(selectedDevices);
        var newSelectedValues = selectedDevices.concat(contextValue.selectedRowIdInSubTable)
        const uniqueSet = new Set(newSelectedValues);
        const resultArray = Array.from(uniqueSet);
        contextValue.setSelectedRowIdInSubTable(resultArray);
    }, [selectedDevices]);

    var dataArr: any = [];
    useEffect(() => {
        console.log("sub table=", contextValue.selectedRowIdInSubTable);
        contextValue.selectedRowIdInSubTable.map((val: any, i: any) => {
            dataArr.push({
                id: i,
                checkbox: "hide",
                selected: { label: <Caption1> {val} </Caption1>, id: `${i}` },
            });
        });
        dataArr.length > 0 ? setSelectedTableData(dataArr) : setSelectedTableData([]);
        contextValue.selectedRowIdInTable.length > 0 ? setIconEnabled(true) : setIconEnabled(false);
    }, [contextValue.selectedRowIdInTable, contextValue.selectedRowIdInSubTable]);

    useEffect(() => {
        const props: any = {
            setDevicesOfTenant: setDevicesOfTenant,
            csvDevicesList: csvDevicesList
        }
        { devicesOfTenant === null && csvDevicesList.length > 0 && Groups_func(props) }
    }, [devicesOfTenant, csvDevicesList, deviceSearchVal, overlayFilterArray, isOverlayFilter]);

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink style={BreadcrumbsBorder}>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        {contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem grow shrink>
                            <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                                <StackItem><Text></Text></StackItem>
                                <StackItem grow shrink>
                                    {/* <Breadcrumbs pageName="Alert" subPageName="" subPageLink="#" />  */}
                                    <Breadcrumbs
                                        items={[
                                        { name: "Manage", link: "/home" },
                                        { name: "Troubleshoot", link: "/manage/troubleshoot/alert" },
                                        { name: "Alert", link: "/manage/troubleshoot/alert" },
                                        { name: contextValue.selectedRowDetails.name, link: "/manage/troubleshoot/alert" },
                                        { name: "Devices", link: "#" }
                                        ]} 
                                    />
                                </StackItem>
                            </Stack>
                        </StackItem>}
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem style={DynamicBoxingCSS}>
                        <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }} horizontal>
                            <StackItem style={DynamicBoxingCSS}>
                                {/* pages code starts here */}
                                <Stack style={DynamicBoxingCSS}>
                                    <FluentProvider style={DynamicBoxingCSS} theme={dashboardTheme}>
                                        <Stack style={DynamicBoxingCSS} horizontal>
                                            {/* SPACING BETWEEN INLINE AND PAGE */}
                                            <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                                            <StackItem style={dividerWidthStyle}>
                                                <Stack style={DynamicBoxingCSS} tokens={{ childrenGap: 10 }}>
                                                    <StackItem>
                                                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                        <Divider />
                                                    </StackItem>
                                                    <StackItem>
                                                        {(contextValue?.logedInFrom === undefined || contextValue?.logedInFrom?.device?.length === undefined) &&
                                                            <StackItem style={wraperStyle}>
                                                                <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                                                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                                                        <StackItem>
                                                                        <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"for Devices"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                                        </StackItem>
                                                                        <StackItem>
                                                                            <MenuDropdown open={filterMenuOpen} btn={
                                                                                <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                                                                        <Body1> Filter </Body1>
                                                                                    </Stack>
                                                                                </MenuButton>
                                                                            } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                                                                <Divider />
                                                                                <MenuList>
                                                                                    <Stack tokens={{ childrenGap: 5 }}>
                                                                                        <StackItem> <Text></Text> </StackItem>
                                                                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                                        <DropdownComponent optionData={columns1} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                                                                                        <StackItem> <Divider /> </StackItem>
                                                                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                                        {/* <DropdownComponent optionData={columns}/> */}
                                                                                        <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                                                                                        <StackItem> <Divider /> </StackItem>
                                                                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                            <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                                                                            <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                                                                        </Stack>
                                                                                    </Stack>
                                                                                </MenuList>
                                                                            </>} />
                                                                        </StackItem>
                                                                        <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                                                            <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                                                </Stack>
                                                                            </Button>
                                                                        </StackItem>
                                                                    </Stack>
                                                                    {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                                                                </Stack>
                                                                {filterArray.length > 0 && <Stack>
                                                                    <Stack wrap horizontal >
                                                                        {filterArray.length > 0 && filterArray.map((item, index) => (
                                                                            <Button shape="circular" size="small">
                                                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                                    <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                                    <StackItem>
                                                                                        <Stack tokens={{ childrenGap: 1 }}>
                                                                                            <StackItem><Text></Text></StackItem>
                                                                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                                        </Stack>
                                                                                    </StackItem>
                                                                                </Stack>
                                                                            </Button>
                                                                        ))}
                                                                    </Stack>
                                                                </Stack>}
                                                            </StackItem>}
                                                        <Stack tokens={{ childrenGap: 10 }}>
                                                            <StackItem><Text></Text></StackItem>
                                                            <StackItem><Text></Text></StackItem>
                                                        </Stack>

                                                        {tableData.length > 0 && !loading && <Stack horizontal enableScopedSelectors horizontalAlign="space-between">
                                                            <StackItem> <Caption1> Showing {((currentPageNo - 1) * 10) + 1} to {(currentPageNo * 10) > totalRecords ? totalRecords : (currentPageNo * 10)} of {totalRecords} Records </Caption1> </StackItem>
                                                        </Stack>}
                                                    </StackItem>

                                                    {/* {devicesOfTenant == null && csvDevicesList.length > 0 && <Groups_func setDevicesOfTenant={setDevicesOfTenant} csvDevicesList={csvDevicesList} />} */}

                                                    {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                                </Stack>
                                            </StackItem>
                                        </Stack>
                                    </FluentProvider>
                                </Stack>
                                <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} />
                            </StackItem>
                            <StackItem><Text></Text></StackItem>
                        </Stack>
                    </StackItem>
                    {isToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={isToast} toastIntent="success" position="top-end" title="Success" message="Executed Successfully" footer="" />}
                    {refreshToast && <ToastComponent setmessagebar={setIsToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}
                    {troubleshootErrorMsg && (<ToastComponent setmessagebar={setTroubleshootErrorMsg} toastIntent={toastIntent} position="top-end" title={toastIntent.charAt(0).toUpperCase() + toastIntent.slice(1)} message={toastMessage} />)}
                    {messagebar2 && (<ToastComponent setmessagebar={setmessagebar2} toastIntent={toastIntent} position="top-end" title={toastIntent.charAt(0).toUpperCase() + toastIntent.slice(1)} message={toastMessage} />)}
                    {previousJob && <ToastComponent setmessagebar={setIsToast} isToastEnabled={previousJob} toastIntent="info" position="top-end" title="Warning" message={'Previous Deployement Pending, Clear it first'} footer="" />}
                    <StackItem><Text></Text></StackItem>
                </Stack>
            </FullScreen>
        </>
    );
};
